export { resolveInvokeModel } from "./resolveInvokeModel.js";
export { buildInvokeModelResolverOptions } from "./buildResolverOptions.js";
export { mapResolutionToRouterConfig } from "./mapResolutionToRouterConfig.js";
export { applyOpenRouterInvokeRouting } from "./applyOpenRouterInvokeRouting.js";
export type { ApplyOpenRouterInvokeRoutingOptions } from "./applyOpenRouterInvokeRouting.js";
export {
  enrichModelResolutionError,
  ModelProfileUnroutableError,
  MODEL_PROFILE_UNROUTABLE,
} from "./enrichModelResolutionError.js";
export {
  resolvePreferOpenRouterPreference,
  resolvePreferOpenRouter,
  readPreferOpenRouterFromEnv,
  resolveOpenRouterApiKey,
} from "./preferOpenRouter.js";
export {
  parsePreferOpenRouter,
  normalizeInvokeModel,
  resolveAndNormalizeInvokeModel,
  resolveAndNormalizeBundledInvokeModel,
  normalizeGatewayWireId,
  isGatewayWireId,
  formatGatewayWireId,
  GATEWAY_PROVIDERS,
} from "@x12i/ai-profiles";
export type {
  NormalizeInvokeModelInput,
  NormalizedInvokeModel,
  NormalizeInvokeModelOptions,
  ResolveAndNormalizeInvokeModelOptions,
  InvokeModelRouting,
  NormalizedGatewayWireId,
  GatewayProvider,
} from "@x12i/ai-profiles";
export {
  createAiToolsInvokeClient,
  getAiToolsInvokeClient,
  resetAiToolsInvokeClientForTests,
} from "./client.js";
export type {
  AiToolsInvokeClient,
  CreateAiToolsInvokeClientOptions,
} from "./client.js";
export type {
  InvokeModelResolutionInput,
  InvokeModelResolutionOptions,
  InvokeModelResolutionResult,
  InvokeRouterConfigSlice,
  InvokeModelResolutionDiagnostics,
  PreferOpenRouterOptions,
} from "./types.js";
